import React, { useId, useRef } from "react";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FIELD_TIPS } from "./fieldTips";
import "./FieldTooltip.css";

/**
 * The (i) beside a field label, with the field's help text (see fieldTips.js) in the same tooltip the Bank Guarantee page uses.
 * Put it inside the label: <Form.Label>Company Name <FieldTooltip name="companyName" /></Form.Label>
 *
 * Hover shows the tip, as on the Bank Guarantee page. From the keyboard, Tab to the (i) shows it and Escape or Tab away hides it.
 * Screen readers hear "More information" and then the tip, which the icon points at as its description. (The tip is not in the
 * icon's own label: the icon sits inside the field's <label>, so that would become part of the input's name.)
 */
const FieldTooltip = ({ name }) => {
  const tip = FIELD_TIPS[name];
  const trigger = useRef(null);
  const tipId = `field-tip-${name}-${useId().replace(/:/g, "")}`;
  if (!tip) return null;

  const show = () => ReactTooltip.show(trigger.current);
  const hide = () => ReactTooltip.hide(trigger.current);

  return (
    <>
      {" "}
      <span
        ref={trigger}
        className="field-tooltip-trigger"
        role="img"
        aria-label="More information"
        aria-describedby={tipId}
        tabIndex={0}
        data-tip
        data-for={tipId}
        onFocus={show}
        onBlur={hide}
        onKeyDown={(event) => event.key === "Escape" && hide()}
      >
        <FontAwesomeIcon
          icon={faInfoCircle}
          color="var(--bg-theme-light)"
          style={{ width: "10px", height: "10px", marginBlockEnd: "2px" }}
        />
      </span>
      <ReactTooltip id={tipId} place="top" effect="solid" className="bg-tooltip-custom">
        {tip}
      </ReactTooltip>
    </>
  );
};

export default FieldTooltip;
